import React from 'react';
import { useTrans } from 'base/utils/i18n'

type IProps = {
    deliveryTime?: string;
    className?: string;
}

const DeliveryTime: React.FC<IProps> = (props) => {

    const { deliveryTime, className } = props;
    const { t } = useTrans();

    return !deliveryTime ? null : (
        <>
            {deliveryTime && (
                <span className={className}>
                    {t('web_shop_crowdfunding_estimated_to_ship_in_deliverytime', {
                        deliveryTime: deliveryTime,
                    })}
                </span>
            )}

        </>
    );
};

export default DeliveryTime